import { createRestSlice } from "./restSlice";

export type AgentFunction = {
  id: string;
  agentId: string;
  name: string;
  displayName?: string; // Make optional for backward compatibility
  code: string;
  codePath: string;
  isMultifile: boolean;
  language: string;
  strategy: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const agentFunctionSlice = createRestSlice<AgentFunction>("agentFunctions", "/v1/agents/:agentId/functions");

export const agentFunctionReducer = agentFunctionSlice.reducer;
export const agentFunctionActions = agentFunctionSlice.actions;
